export default "//cdn.scentbird.com/assets/frontbird-site/images/conditioner_e72a87.png";